import React from 'react'
import { theme } from '../../../Assets/Styles/theme'
import IconSubstract from '../../../Assets/Images/icons/newIcons/iconSubstract'

const ButtonSubstract = ({ onClick }) => {
  return (
    <button
      style={{
        width: '24px',
        height: '25px',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
      }}
      onClick={onClick}
    >
      <IconSubstract color={theme.colors.primary} />
    </button>
  )
}

export default ButtonSubstract
